(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stellr-donation-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('close', (event) => {
    if (event.target.id === 'StellrLoveMercy') event.target.querySelectorAll('video').forEach((video) => video.pause());
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stellr-donation-widget"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stellr-donation-preview')) {
    const widgets = new Set();
    const checkoutLocks = new Map();
    let busy = false;
    let revision = 0;
    const cartRequest = async (url, body) => {
      const response = await fetch(url, {
        method: body ? 'POST' : 'GET',
        headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        cache: 'no-store',
        ...(body ? { body: JSON.stringify(body) } : {}),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'cart');
      return result;
    };
    const syncCheckout = () => {
      if (busy) {
        document.querySelectorAll('button[name="checkout"]').forEach((button) => {
          if (!checkoutLocks.has(button)) checkoutLocks.set(button, button.disabled);
          button.disabled = true;
        });
      } else {
        checkoutLocks.forEach((disabled, button) => { if (button.isConnected) button.disabled = disabled; });
        checkoutLocks.clear();
      }
    };
    const syncCart = (cart) => widgets.forEach((widget) => { widget.cart = cart; widget.renderDonation(); });
    document.addEventListener('submit', (event) => {
      if (busy && event.target.querySelector('button[name="checkout"]')) event.preventDefault();
    }, true);
    customElements.define('stellr-donation-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.cart = JSON.parse(this.querySelector('[data-donation-cart]').textContent);
        widgets.add(this);
        this.onclick = (event) => {
          const button = event.target.closest('[data-donation-amount], [data-donation-remove]');
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          if (!busy && !button.disabled) this.changeDonation(button);
        };
        this.renderDonation();
        syncCheckout();
      }
      disconnectedCallback() { widgets.delete(this); this.bound = false; }
      donationLines(cart = this.cart) {
        return (cart.items || []).filter((item) => String(item.product_id) === this.dataset.productId);
      }
      announce(message) {
        widgets.forEach((widget) => { widget.querySelector('[data-donation-status]').textContent = message; });
      }
      renderDonation() {
        const lines = this.donationLines();
        this.setAttribute('aria-busy', String(busy));
        this.querySelectorAll('[data-donation-amount]').forEach((button) => {
          button.disabled = busy || !button.dataset.donationVariant || this.cart.currency !== 'AUD';
          button.setAttribute('aria-pressed', String(lines.length === 1 && lines[0].quantity === 1 && String(lines[0].variant_id) === button.dataset.donationVariant));
        });
        this.querySelector('[data-donation-remove]').disabled = busy;
        this.querySelector('[data-donation-selection]').hidden = lines.length === 0;
        this.querySelector('[data-donation-line-amount]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: 'AUD' }).format(lines.reduce((total, item) => total + item.final_line_price, 0) / 100);
      }
      async changeDonation(button) {
        const variantId = button.dataset.donationVariant || '';
        const removing = button.hasAttribute('data-donation-remove');
        if (!removing && !variantId) return;
        busy = true;
        revision += 1;
        widgets.forEach((widget) => widget.renderDonation());
        syncCheckout();
        this.announce('');
        let restoreFocus = false;
        try {
          const cart = await cartRequest(this.dataset.cartUrl);
          if (cart.currency !== 'AUD') throw new Error(this.dataset.unavailableMessage);
          const lines = this.donationLines(cart);
          const keep = removing ? null : lines.find((item) => String(item.variant_id) === variantId);
          const updates = Object.fromEntries(lines.map((item) => [item.key, item === keep ? 1 : 0]));
          if (!removing && !keep) updates[variantId] = 1;
          const result = await cartRequest(this.dataset.updateUrl, {
            updates,
            sections: window.StellrCommerce.cartSections(),
            sections_url: window.location.pathname,
          });
          window.StellrCommerce.refreshCart(result, button, false);
          syncCart(result);
          this.announce(removing ? this.dataset.removedMessage : this.dataset.addedMessage);
          restoreFocus = true;
          if (!result.sections || Object.values(result.sections).some((section) => !section)) window.location.reload();
        } catch (error) {
          try {
            const cart = await cartRequest(this.dataset.cartUrl);
            const url = new URL(window.location.href);
            url.searchParams.set('sections', window.StellrCommerce.cartSections());
            cart.sections = await cartRequest(url.toString());
            window.StellrCommerce.refreshCart(cart, button, false);
            syncCart(cart);
            restoreFocus = true;
          } catch {}
          this.announce(error.message === 'cart' || error instanceof TypeError ? this.dataset.errorMessage : error.message);
        } finally {
          busy = false;
          widgets.forEach((widget) => widget.renderDonation());
          syncCheckout();
          if (restoreFocus) {
            const current = [...widgets].find((widget) => widget.dataset.placement === this.dataset.placement);
            current?.querySelector(removing ? '[data-donation-amount]' : `[data-donation-variant="${variantId}"]`)?.focus();
          }
        }
      }
    });
    document.addEventListener('stellr:cart-updated', async () => {
      if (busy) return;
      const widget = widgets.values().next().value;
      if (!widget) return;
      const currentRevision = ++revision;
      try {
        const cart = await cartRequest(widget.dataset.cartUrl);
        if (!busy && currentRevision === revision) syncCart(cart);
      } catch { widget.announce(widget.dataset.errorMessage); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stellr-facets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stellr-collection-tools')) {
    customElements.define('stellr-collection-tools', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.form = this.querySelector('form');
        this.filters = this.querySelector('details');
        this.fitPanel = () => {
          if (!this.filters?.open) return;
          const panel = this.querySelector('.stellr-collection-tools__panel');
          panel.style.maxHeight = '';
          if (innerWidth < 750 && panel.getBoundingClientRect().bottom > innerHeight - 12) {
            this.scrollIntoView({ block: 'start', behavior: 'instant' });
          }
          panel.style.maxHeight = Math.min(520, Math.max(120, innerHeight - panel.getBoundingClientRect().top - 12)) + 'px';
        };
        this.filters?.addEventListener('toggle', this.fitPanel);
        window.addEventListener('resize', this.fitPanel);
        this.onchange = (event) => {
          if (event.target.matches('[name="sort_by"]')) this.form.requestSubmit();
        };
        this.onsubmit = () => {
          this.querySelectorAll('[data-filter-price]').forEach((input) => { input.disabled = input.value.trim() === ''; });
        };
        this.onkeydown = (event) => {
          if (event.key === 'Escape' && this.filters?.open) {
            event.preventDefault();
            this.filters.open = false;
            this.filters.querySelector('summary').focus();
          }
        };
        this.onOutside = (event) => {
          if (this.filters?.open && !this.contains(event.target)) this.filters.open = false;
        };
        this.onFocusOut = (event) => {
          if (this.filters?.open && event.relatedTarget && !this.filters.contains(event.relatedTarget)) this.filters.open = false;
        };
        this.addEventListener('focusout', this.onFocusOut);
        document.addEventListener('pointerdown', this.onOutside);
      }
      disconnectedCallback() {
        this.filters?.removeEventListener('toggle', this.fitPanel);
        window.removeEventListener('resize', this.fitPanel);
        document.removeEventListener('pointerdown', this.onOutside);
        this.removeEventListener('focusout', this.onFocusOut);
        this.bound = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
